<div mat-dialog-title>
  <div>Update County Data</div>
  <div (click)="onNoClick()" class="close-icon-container">
    <fa-icon [icon]="['far', 'xmark']" class="gray"></fa-icon>
  </div>
</div>
<mat-divider></mat-divider>
<div mat-dialog-content>
  <form [formGroup]="updateCountyForm">
    <mat-form-field class="full-width" subscriptSizing="dynamic">
      <mat-label>State</mat-label>
      <input data-cy="state" formControlName="state" matInput type="text" />
    </mat-form-field>
    <mat-form-field class="full-width" subscriptSizing="dynamic">
      <mat-label>County Name</mat-label>
      <input data-cy="county" formControlName="county" matInput type="text" />
    </mat-form-field>
    <mat-form-field class="full-width" subscriptSizing="dynamic">
      <mat-label>Regrid Filename</mat-label>
      <input data-cy="regridFile" formControlName="regridFile" matInput type="text" />
    </mat-form-field>
    <mat-checkbox formControlName="available">
      Is Available
    </mat-checkbox>
    <mat-form-field class="full-width" subscriptSizing="dynamic">
      <mat-label>Average ERT</mat-label>
      <input data-cy="averageErt" formControlName="averageErt" matInput placeholder="Average ERT" type="text" />
    </mat-form-field>
  </form>
</div>
<div mat-dialog-actions>
  <button [mat-dialog-close]="false" color="primary" data-cy="button-cancel" mat-stroked-button>Cancel</button>
  <button
    (click)="onSubmit()"
    [disabled]="updateCountyForm.invalid"
    color="primary"
    data-cy="button-submit"
    mat-raised-button>
    Save
  </button>
</div>
